import { DataReader, SerializationUtil } from "@spi/Common/Serialization";
import { PathNode } from "@spi/Common/NavigationMesh";

export class PathNodeGraphReader extends DataReader<PathNode[]> {

    public read(data: Uint8Array): PathNode[] {
        let util = new SerializationUtil().readFrom(data, true);

        let map = new Map<PathNode, Uint32Array>();

        let nodeCount = util.readUint32();
        let nodes = new Array<PathNode>(nodeCount);

        for (let i = 0; i < nodeCount; i++) {
            let reference = util.readString();

            let min = util.readVec3();
            let max = util.readVec3();

            let node = new PathNode(min, max);
            node.id = i;
            node.reference = reference;

            nodes[i] = node;

            map.set(node, util.readVaryingUint32Array());

            let rowCount = util.readUint32();
            let rows = new Array<Float32Array>(rowCount);
            for (let r = 0; r < rowCount; r++) {
                rows[r] = util.readVaryingFloat32Array();
            }

            node.heightGrid = rows;

        }

        // Fetch the neighbours
        map.forEach((ns, primaryNode) => {
            primaryNode.neighbours = [...ns].map(n => nodes[n]);
        });

        return nodes;
    }

}